'use client';
import React, { useEffect, useState } from 'react';

import { usePathname } from 'next/navigation';

import {
  // initialState,
  LanguageOption,
  GlobalStateContext,
  // GlobalStateDispatchContext,
} from './context';
// import { reducer, ACTIONS } from './reducer';

export const GlobalStateProvider = ({ children }) => {
  const pathname = usePathname();
  const [languageOptions, setLanguageOptions] = useState<LanguageOption[] | null>(null);

  // Reset language options only when path changes
  useEffect(() => {
    setLanguageOptions(null);
  }, [pathname]);

  return (
    <GlobalStateContext.Provider value={{ languageOptions, setLanguageOptions }}>
      {/* <GlobalStateDispatchContext.Provider value={{ setLanguageOptions }}> */}
      {children}
      {/* </GlobalStateDispatchContext.Provider> */}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => React.useContext(GlobalStateContext);

export default GlobalStateProvider;
